// Copyright (C) 2019 TANNER AG

import React from "react";
import * as PropTypes from "prop-types";
import { Query } from "react-apollo";
import defaultParametersQuery from "../queries/defaultparameters";
import { withStyles, Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import { withStore } from "../store/withstore";
import { Spinner } from "../components/spinner";
import { Error } from "../components/error";

const CustomTableCell = withStyles({
	body: {
		fontSize: 15,
		lineHeight: "20px",
		border: "none",
		fontFamily: "MANEurope, Arial, sans-serif",
		"&:first-child": {
			fontWeight: "bold",
			fontStretch: "condensed",
		}
	},
})(TableCell);

const CustomTableRow = withStyles({
	root: {
		height: "30px",
		'&:nth-of-type(even)': {
			backgroundColor: "#f0f1f2",
		}
	}
})(TableRow);

export const DefaultParameterRow = ({ name, value }) => (
	<CustomTableRow>
		<CustomTableCell>{name}</CustomTableCell>
		<CustomTableCell>{value}</CustomTableCell>
	</CustomTableRow>
);

const DefaultParameterTable = (props) => {
	return (
		<Query query={defaultParametersQuery} variables={{ language: props.store.language }} fetchPolicy="network-only">
			{({ error, loading, data }) => {
				if (loading) {
					return <Spinner/>;
				}

				if (error) {
					return (
						<Error message={error}/>
					);
				}

				return (
					<Table>
						<TableBody>
							{data.tcoDefaultParameters.map((parameter, index) => (
								<DefaultParameterRow
									key={index}
									name={parameter.name}
									value={parameter.value}
								/>
							))}
						</TableBody>
					</Table>
				);
			}}
		</Query>
	);
};

DefaultParameterTable.propTypes = {
	store: PropTypes.object
};

export default withStore(DefaultParameterTable);



// WEBPACK FOOTER //
// ./src/tco/defaultparamters/table.js